/* BELLER: auto-otwieranie szuflady koszyka po "Dodaj do koszyka".
   Czeka na zmianę licznika koszyka po kliknięciu przycisku dodania, potem otwiera #cart. */
(function () {
  /* BELLER 24.09.2026: przenoszenia szuflady do <body> juz tu nie ma.
     Szuflada renderuje sie w layout/theme.liquid bezposrednio w <body>, wiec nie trzeba
     jej przestawiac w locie ani trzymac obserwatora zmian na calym dokumencie. */

  /* BELLER 24.09.2026: motyw sam otwiera szuflade po dodaniu do koszyka.
     barracuda-cart.js w addToCart wola this.opener.click(), a opener ma
     onclick="openTopbar(event,'cart')". Odpytywanie /cart.js co 250 ms, do 16 razy,
     bylo wiec zbedne i obciazalo telefon.
     Zapas odpala sie DOPIERO po zakonczeniu zadania /cart/add.js plus 600 ms.
     Koniec zadania poznajemy po klasie added-to-cart, ktora motyw nadaje formularzowi
     w tym samym kroku, w ktorym klika opener. Tuz przed otwarciem sprawdzamy
     control-visible, wiec przy dzialajacym motywie nie leci ani jedno zapytanie. */
  function bmsSzufladaOtwarta() {
    var k = document.getElementById('cart');
    /* control-visible nadaje openTopbar po 50 ms, a topbar-open na body od razu.
       Przy wolnym laczu sprawdzenie samego control-visible potrafilo wypasc w oknie,
       w ktorym motyw juz otwieral szuflade, a klasy jeszcze nie bylo, wiec liczymy oba. */
    if (document.body.classList.contains('topbar-open')) return true;
    return !!(k && (k.classList.contains('control-visible') || k.classList.contains('visible')));
  }

  function bmsOtworz() {
    var k = document.getElementById('cart');
    if (!k || k.classList.contains('control-visible')) return;
    if (typeof window.openTopbar === 'function') {
      try { window.openTopbar(new MouseEvent('click'), 'cart'); return; } catch (err) {}
    }
    document.body.classList.add('topbar-open');
    k.removeAttribute('hidden');
    k.classList.add('control-visible');
    /* motyw dodaje visible w callbacku anime; bez tej klasy closeTopbar nie zdejmie
       topbar-open z body i strona zostalaby pod nieklikalna nakladka */
    setTimeout(function () { k.classList.add('visible'); }, 500);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.barracuda-cart-addToCartButton');
    if (!btn) return;
    var form = btn.closest('form') || document;
    if (form.__bmsZapas) return;
    form.__bmsZapas = true;
    var zrobione = false;
    var obs = new MutationObserver(function () {
      if (zrobione || !form.classList || !form.classList.contains('added-to-cart')) return;
      zrobione = true;
      obs.disconnect();
      clearTimeout(bezpiecznik);
      setTimeout(function () {
        form.__bmsZapas = false;
        if (bmsSzufladaOtwarta()) return;      /* motyw zdazyl, nic nie robimy */
        fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
          .then(function (r) { return r.json(); })
          .then(function (c) { if (c && c.item_count > 0) bmsOtworz(); })
          ['catch'](function () {});
      }, 600);
    });
    if (form.classList) obs.observe(form, { attributes: true, attributeFilter: ['class'] });
    var bezpiecznik = setTimeout(function () { obs.disconnect(); form.__bmsZapas = false; }, 8000);
  }, true);

  /* Proponowane produkty w koszyku: natywne rekomendacje Shopify dla pierwszej pozycji,
     bez produktów już obecnych w koszyku; klik = karta produktu (wybór rozmiaru na PDP). */
  function bmsMoney(cents) {
    if (bmsWalutaKod() !== 'PLN') return bmsCena(cents / 100);
    var v = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return v.replace(',00', '') + ' zł';
  }
  /* BELLER 27.10.2026, waluty: ceny podpowiedzi „Wybierane w zestawie” przy walucie innej niż PLN.
     Kwoty z products.json są już w walucie klienta (zmierzone: CAD 309.00 za 14K), więc dopisek
     „zł” zostaje tylko przy PLN. Format z ustawień sklepu: wzór 1234567 | money z atrybutu
     data-bms-wzor na kontenerze podpowiedzi (sections/main-cart.liquid), ta sama zasada co suwak ceny
     i bms-waluty. CAD dostaje przedrostek CA$, jak reszta sklepu. Przy PLN zapis bez zmian. */
  function bmsWalutaKod() { return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'PLN'; }
  function bmsCena(kwota) {
    var kod = bmsWalutaKod();
    if (kod === 'PLN') return kwota.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' zł';
    var grosze = Math.round(kwota * 100), cale = Math.floor(grosze / 100), reszta = grosze % 100;
    var el = document.querySelector('[data-bms-wzor]');
    var w = el ? (el.getAttribute('data-bms-wzor') || '') : '';
    var i = w.search(/[0-9]/), j = w.length, t;
    if (i >= 0) {
      while (j > 0 && !/[0-9]/.test(w.charAt(j - 1))) j--;
      var rdzen = w.slice(i, j), seps = rdzen.replace(/[0-9]/g, '').split('');
      var zGroszami = rdzen.replace(/[^0-9]/g, '').length >= 7;
      var grupa = zGroszami ? (seps.length > 1 ? seps[0] : '') : (seps[0] || '');
      var dzies = zGroszami && seps.length ? seps[seps.length - 1] : '';
      t = String(cale);
      if (grupa) t = t.replace(/\B(?=(\d{3})+(?!\d))/g, grupa);
      if (reszta && dzies) t += dzies + (reszta < 10 ? '0' : '') + reszta;
      t = w.slice(0, i) + t + w.slice(j);
    } else {
      try { t = new Intl.NumberFormat('en', { style: 'currency', currency: kod, minimumFractionDigits: reszta ? 2 : 0, maximumFractionDigits: 2 }).format(kwota); }
      catch (e) { t = kwota.toFixed(reszta ? 2 : 0) + ' ' + kod; }
    }
    if (kod === 'CAD') t = t.replace(/(^|[^A-Za-z$])\$(?=\s?[0-9])/, '$1CA$$');
    return t;
  }
  var bmsRecsBusy = false;
  var BMS_LINES = ['liquid','cube','elements','raw','round','twirl','promise','soulmate','barbakan','krakowsk','edge','pearl','minimal'];
  function bmsMinPrice(p) { /* products.json: variants[].price jako string */
    var v = (p.variants || []).map(function (x) { return parseFloat(x.price); }).filter(function (x) { return !isNaN(x); });
    return v.length ? Math.min.apply(null, v) : parseFloat(p.price || 0) / 100;
  }
  function bmsCard(p, priceZl, karat) {
    var img = '';
    if (p.images && p.images.length) img = (p.images[0].src || p.images[0]);
    else if (p.featured_image) img = p.featured_image;
    if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=600';
    var url = p.url || ('/products/' + p.handle);
    var avail = (p.variants || []).filter(function (v) { return v.available !== false; });
    /* kruszec z koszyka: przy 18K dodajemy wariant 18K (i pokazujemy jego cenę) */
    var chosen = avail[0];
    if (karat === '18k') {
      var v18 = avail.filter(function (v) { return ((v.title || '') + '').toLowerCase().indexOf('18k') !== -1; })[0];
      if (v18) { chosen = v18; priceZl = parseFloat(v18.price) || priceZl; }
    }
    var priceTxt = bmsCena(priceZl); /* BELLER 27.10.2026: waluta klienta, przy PLN jak dotąd */
    var vid = chosen ? chosen.id : '';
    /* na PDP kierujemy TYLKO gdy trzeba wybrać rozmiar; sam materiał (14K/18K) = dodaj bazowy 14K
       (cena na karcie to właśnie cena bazowa) */
    var sizeLike = (p.options || []).some(function (o) {
      var n = ((o && o.name) ? o.name : o).toString().toLowerCase();
      return n.indexOf('rozmiar') !== -1 || n.indexOf('size') !== -1;
    });
    var multi = (avail.length > 1 && sizeLike) ? 1 : 0;
    /* TWARDA REGULA: rodzina wariantow zawsze po opcji Material/Proba zgodnie z koszykiem
       (14K w koszyku -> tylko 14K/585; 18K -> tylko 18K/750), etykiety ZAWSZE z opcji Rozmiar
       - kolejnosc opcji produktu bywa rozna ("14K / 4" albo "38 / 14K"), wiec nie parsujemy tytulu */
    var vars = '';
    if (multi) {
      var optNames = (p.options || []).map(function (o) { return ((o && o.name) ? o.name : o).toString().toLowerCase(); });
      var matIdx = -1, sizeIdx = -1;
      for (var oi = 0; oi < optNames.length; oi++) {
        if (matIdx === -1 && (optNames[oi].indexOf('materia') !== -1 || optNames[oi].indexOf('prob') !== -1 || optNames[oi].indexOf('prób') !== -1 || optNames[oi].indexOf('kruszec') !== -1)) matIdx = oi;
        if (sizeIdx === -1 && (optNames[oi].indexOf('rozmiar') !== -1 || optNames[oi].indexOf('size') !== -1)) sizeIdx = oi;
      }
      var fam = avail;
      if (matIdx !== -1) {
        var wants = (karat === '18k') ? ['18', '750'] : ['14', '585'];
        var famM = avail.filter(function (v) {
          var m = ((v['option' + (matIdx + 1)] || '') + '').toLowerCase();
          return wants.some(function (w) { return m.indexOf(w) !== -1; });
        });
        if (famM.length) fam = famM;
      }
      var seen = {};
      vars = encodeURIComponent(JSON.stringify(fam.map(function (v) {
        var l = '';
        if (sizeIdx !== -1) l = ((v['option' + (sizeIdx + 1)] || '') + '').trim();
        if (!l) { var t = (v.title || '') + ''; l = (t.indexOf('/') !== -1 ? t.split('/').pop() : t).trim(); }
        return { id: v.id, l: l };
      }).filter(function (x) { if (!x.l || seen[x.l]) return false; seen[x.l] = 1; return true; })));
    }
    return '<a class="bms-cart-rec" href="' + url + '">'
      + (img ? '<span class="bms-cart-rec-img"><img src="' + img + '" alt="" loading="lazy">'
        + '<button type="button" class="bms-cart-rec-add" data-vid="' + vid + '" data-multi="' + multi + '" data-url="' + url + '" data-vars="' + vars + '" aria-label="Dodaj do koszyka">+</button>'
        + '</span>' : '')
      + '<span class="bms-cart-rec-name">' + p.title + '</span>'
      + '<span class="bms-cart-rec-price">' + priceTxt + '</span></a>';
  }
  /* „+" na karcie propozycji: 1 wariant = dodaj od razu; wiele wariantów (rozmiary) = karta produktu */
  function bmsUpdateBadge() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var el = document.querySelector('.barracuda-cart-opener .count');
      if (el) el.textContent = '' + c.item_count;
      var cc = document.querySelector('.barracuda-cart-opener .count-container');
      if (cc && c.item_count > 0) cc.classList.remove('hide');
    }).catch(function () {});
  }
  /* ptaszek potwierdzenia w stylu naszego X z menu: cienka kreska 1px, 24x24 */
  var BMS_CHECK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 12.5 L10 18 L19.5 6.5"/></svg>';
  /* imiennik BELLER (geometria symbolu ze strony Certyfikacji) jako stan ladowania */
  var BMS_MARK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="240 180 520 640" fill="none" stroke="currentColor" stroke-width="52" stroke-linecap="round" stroke-linejoin="round" class="bms-load-mark" aria-hidden="true"><rect x="369" y="262" width="262" height="476"/><path d="M369 262 A131 119 0 0 1 369 500"/><path d="M500 500 A131 119 0 0 1 500 738"/></svg>';
  function bmsAddToCart(vid, onOk, onErr) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        bmsUpdateBadge();
        var opener = document.querySelector('.icon-cart-bag') && document.querySelector('.icon-cart-bag').closest('a');
        if (opener) opener.click();
        if (onOk) onOk();
      })
      .catch(function () { if (onErr) onErr(); });
  }
  function bmsCloseSizePickers() {
    var open = document.querySelectorAll('.bms-rec-sizes');
    [].forEach.call(open, function (el) { el.parentNode && el.parentNode.removeChild(el); });
  }
  document.addEventListener('click', function (ev) {
    /* wybor rozmiaru na kafelku propozycji */
    var sb = ev.target.closest('.bms-rec-size');
    if (sb) {
      ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
      if (sb.disabled) return;
      sb.disabled = true; sb.innerHTML = BMS_MARK_SVG;
      bmsAddToCart(sb.dataset.vid,
        function () { bmsCloseSizePickers(); },
        function () { sb.disabled = false; sb.textContent = sb.dataset.l || '?'; });
      return;
    }
    var btn = ev.target.closest('.bms-cart-rec-add');
    if (!btn) {
      /* klik poza kafelkami zamyka otwarty wybor rozmiaru */
      if (!ev.target.closest('.bms-rec-sizes')) bmsCloseSizePickers();
      return;
    }
    ev.preventDefault(); ev.stopPropagation(); ev.stopImmediatePropagation();
    if (btn.dataset.multi === '1' && btn.dataset.vars) {
      /* pierscionki itp.: mini-wybor rozmiaru w panelu zamiast przejscia na PDP */
      var card = btn.closest('.bms-cart-rec');
      var wasOpen = card && card.querySelector('.bms-rec-sizes');
      bmsCloseSizePickers();
      if (wasOpen || !card) return;
      var list;
      try { list = JSON.parse(decodeURIComponent(btn.dataset.vars)); } catch (e) { list = null; }
      if (!list || !list.length) { window.location.href = btn.dataset.url; return; }
      var isEn = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
      var wrap = document.createElement('span');
      wrap.className = 'bms-rec-sizes';
      var h = '<span class="bms-rec-sizes-t">' + (isEn ? 'Size' : 'Rozmiar') + '</span>';
      for (var i = 0; i < list.length; i++) {
        h += '<button type="button" class="bms-rec-size" data-vid="' + list[i].id + '" data-l="' + list[i].l + '">' + list[i].l + '</button>';
      }
      wrap.innerHTML = h;
      (card.querySelector('.bms-cart-rec-img') || card).appendChild(wrap);
      return;
    }
    if (btn.dataset.multi === '1' || !btn.dataset.vid) { window.location.href = btn.dataset.url; return; }
    if (btn.disabled) return;
    btn.disabled = true; btn.innerHTML = BMS_MARK_SVG;
    bmsAddToCart(btn.dataset.vid,
      function () { btn.innerHTML = BMS_CHECK_SVG; },
      function () { btn.disabled = false; btn.textContent = '+'; });
  }, true);
  function bmsFillRecs() {
    var box = document.querySelector('#cart .bms-cart-recs');
    if (!box || box.childElementCount > 0 || bmsRecsBusy) return;
    bmsRecsBusy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      if (!cart.items || !cart.items.length) { box.style.display = 'none'; bmsRecsBusy = false; return; }
      var inCartIds = cart.items.map(function (i) { return i.product_id; });
      var cartTitles = cart.items.map(function (i) { return (i.product_title || i.title || '').toLowerCase(); }).join(' ');
      /* linia zestawu z koszyka, np. "liquid" */
      var line = null;
      /* co klient PRZEGLADA (PDP): sygnal do doboru, gdy koszyk nie wskazuje linii */
      var viewedTitle = ((document.querySelector('meta[property="og:title"]') || {}).content || '').toLowerCase();
      for (var i = 0; i < BMS_LINES.length; i++) { if (cartTitles.indexOf(BMS_LINES[i]) !== -1) { line = BMS_LINES[i]; break; } }
      if (!line) { for (var i2 = 0; i2 < BMS_LINES.length; i2++) { if (viewedTitle.indexOf(BMS_LINES[i2]) !== -1) { line = BMS_LINES[i2]; break; } } }
      /* pula: kolczyki złote + srebrne (tanie dodatki + dopasowanie zestawu) */
/* BELLER 7.09.2026. Pula rozszerzona o bransoletki.
         POLICZONE z 282 zamowien od 1.09.2025: wsrod produktow do 1 500 zl najlepiej
         rotuja Pierscionek zloty Twirl N5 (6 szt.), Bransoletka srebrna sztywna Raw N1
         (6 szt.), Pierscionek zloty Raw N7 (5 szt.) i Pierscionek srebrny Liquid N6 (4 szt.).
         Dwie z czterech to bransoletki, a tych w puli w ogole nie bylo. */
      var bmsFetches = [
        '/collections/earrings/products.json?limit=100',
        '/collections/kolczyki-srebrne/products.json?limit=100',
        '/collections/rings/products.json?limit=100',
        '/collections/pierscionki-srebrne/products.json?limit=100',
        '/collections/bransoletki-zlote/products.json?limit=100',
        '/collections/bransoletki-srebrne/products.json?limit=100'
      ];
      /* diamentowy koszyk: brylant/zareczyny albo pozycja >= 7000 zl -> pula rosnie o BRIDAL i Promise */
      var bmsMaxUnit = 0;
      (cart.items || []).forEach(function (i) { var u = (i.price || 0) / 100; if (u > bmsMaxUnit) bmsMaxUnit = u; });
      var bmsDiamond = bmsMaxUnit >= 7000 || /brylant|diamond|zar\u0119czynow|zareczynow/.test(cartTitles);
      if (bmsDiamond) {
        bmsFetches.push('/collections/bridal/products.json?limit=100');
        bmsFetches.push('/collections/engagements-rings/products.json?limit=100');
      }
      /* Kolekcja Krakowska: koszyk albo przegladana karta z tej kolekcji -> dopelniamy zestaw z niej */
      var BMS_KRAK = /krakowsk|witra\u017c|witraz|barbakan|wawelsk/;
      var bmsKrak = BMS_KRAK.test(cartTitles) || BMS_KRAK.test(((document.querySelector('meta[property="og:title"]') || {}).content || '').toLowerCase());
      if (bmsKrak) bmsFetches.push('/collections/kolekcja-krakowska/products.json?limit=100');
      Promise.all(bmsFetches.map(function (u) { return fetch(u).then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }); })).then(function (both) {
        var seenIds = {};
        var merged = [];
        both.forEach(function (b) { merged = merged.concat(b.products || []); });
        merged = merged.filter(function (p) { if (seenIds[p.id]) return false; seenIds[p.id] = 1; return true; });
        var pool = merged.filter(function (p) { return inCartIds.indexOf(p.id) === -1 && (p.variants || []).some(function (v) { return v.available !== false; }); });
        pool.forEach(function (p) { p._min0 = bmsMinPrice(p); });
        pool = pool.filter(function (p) { return p._min0 > 0; });
        pool.forEach(function (p) { p._min = bmsMinPrice(p); p._t = (p.title || '').toLowerCase(); });
        pool.sort(function (a, b) { return a._min - b._min; });
        /* kruszec koszyka: srebro -> srebrne podpowiedzi; złoto -> złote (14K domyślnie, przy 18K „+" doda 18K) */
        var cartGold = cartTitles.indexOf('złot') !== -1 || cartTitles.indexOf('zlot') !== -1 || cartTitles.indexOf('gold') !== -1;
        var cartSilver = !cartGold && (cartTitles.indexOf('srebrn') !== -1 || cartTitles.indexOf('silver') !== -1);
        var cartKarat = '14k';
        (cart.items || []).forEach(function (i) {
          var vt = ((i.variant_title || '') + ' ' + ((i.options_with_values || []).map(function (o) { return o.value; }).join(' '))).toLowerCase();
          if (vt.indexOf('18k') !== -1) cartKarat = '18k';
        });
        function metalOk(p) {
          if (cartGold) return p._t.indexOf('złot') !== -1 || p._t.indexOf('zlot') !== -1 || p._t.indexOf('gold') !== -1;
          if (cartSilver) return p._t.indexOf('srebrn') !== -1 || p._t.indexOf('silver') !== -1;
          return true;
        }
        /* BELLER 7.09.2026: podpowiadamy DODATEK, nie druga duza rzecz. Produkty do 1 500 zl
         ida na przod puli, reszta zostaje jako zapas, gdyby tanich zabraklo. */
      var BMS_PULAP = 1500;
      pool = pool.filter(function (p) { return p._min <= BMS_PULAP; })
             .concat(pool.filter(function (p) { return p._min > BMS_PULAP; }));
      /* preferencja kruszcu: pasujące na przód puli (stabilnie, nadal wg ceny) */
        pool = pool.filter(metalOk).concat(pool.filter(function (p) { return !metalOk(p); }));
        /* BELLER 7.09.2026, decyzja usera: na telefonie TRZY kafle, na komputerze CZTERY.
         Do tego DWA ostatnie miejsca sa zarezerwowane na dodatek do 1 500 zl, zeby
         reguly kolekcyjne nie zajely calego rzedu drogimi propozycjami. */
      var BMS_ILE = window.matchMedia('(max-width: 767px)').matches ? 3 : 4;
      var BMS_ILE_TEMAT = Math.max(1, BMS_ILE - 2);
      var picks = [], used = {};
        function take(p) { if (p && !used[p.id] && picks.length < BMS_ILE) { used[p.id] = 1; picks.push(p); } }
      /* take z limitem tematycznym: reguly kolekcyjne nie moga zajac calego rzedu */
      function takeTemat(p) { if (picks.length < BMS_ILE_TEMAT) take(p); }
        function isRing(p) { return p._t.indexOf('pierścionek') !== -1 || p._t.indexOf('pierscionek') !== -1 || p._t.indexOf('ring') === 0; }
        function isEarring(p) { return p._t.indexOf('kolczyki') !== -1 || p._t.indexOf('earring') !== -1; }
        /* komplementarnie: co już jest w koszyku? */
        var cartHasRing = cartTitles.indexOf('pierścionek') !== -1 || cartTitles.indexOf('pierscionek') !== -1 || cartTitles.indexOf('obrączka') !== -1;
        var cartHasEarrings = cartTitles.indexOf('kolczyki') !== -1;
        /* 00) Kolekcja Krakowska: dopelnienie zestawu z kolekcji, w lidze cenowej koszyka */
        if (bmsKrak) {
          var kV = bmsMaxUnit || 0;
          var kBand = function (p) { return !kV || (p._min >= kV * 0.15 && p._min <= kV * 0.9); };
          var kra = pool.filter(function (p) { return BMS_KRAK.test(p._t); });
          var kraDiff = kra.filter(function (p) { return !(cartHasRing && isRing(p)) && !(cartHasEarrings && isEarring(p)); });
          takeTemat(kraDiff.filter(kBand)[0] || kraDiff[0]);
          takeTemat(kra.filter(kBand)[0] || kra[0]);
        }
        /* 0) diamentowy koszyk: komplet slubny BRIDAL w lidze cenowej koszyka (15-70% wartosci) */
        if (bmsDiamond) {
          var bmsV = bmsMaxUnit;
          var bmsInBand = function (p) { return p._min >= bmsV * 0.15 && p._min <= bmsV * 0.7; };
          var bmsPickBand = function (c) { var b = c.filter(bmsInBand); return (b.length ? b : c)[0]; };
          var bmsBands = pool.filter(function (p) { return (p._t.indexOf('obrączka') !== -1 || p._t.indexOf('obraczka') !== -1) && p._t.indexOf('bridal') !== -1; });
          var bmsBEar = pool.filter(function (p) { return p._t.indexOf('kolczyki') !== -1 && p._t.indexOf('bridal') !== -1; });
          var bmsBBrac = pool.filter(function (p) { return p._t.indexOf('bransoletka') !== -1 && p._t.indexOf('bridal') !== -1; });
          takeTemat(bmsPickBand(bmsBands));
          takeTemat(bmsPickBand(bmsBEar));
          if (line) { var bmsSL = pool.filter(function (p) { return p._t.indexOf(line) !== -1; }); takeTemat(bmsSL.filter(bmsInBand)[0] || bmsSL[0]); }
          takeTemat(bmsPickBand(bmsBBrac));
        }
        /* 1) zestaw: ta sama linia wzornicza, ale INNA kategoria niż w koszyku */
        if (line) {
          var sameLine = pool.filter(function (p) { return p._t.indexOf(line) !== -1; });
          if (cartHasRing) takeTemat(sameLine.filter(isEarring)[0]);
          else if (cartHasEarrings) takeTemat(sameLine.filter(isRing)[0]);
          takeTemat(sameLine[0]);
        }
        /* 2) komplementarny pierścionek: najtańszy Elements albo Raw (pula już uporządkowana wg kruszcu koszyka) */
        var compRings = pool.filter(function (p) { return isRing(p) && (p._t.indexOf('elements') !== -1 || p._t.indexOf('raw') !== -1); });
        take(compRings[0]);
        /* 3) tanie dodatki: najtańsze kolczyki Cube w kruszcu koszyka */
        var cubes = pool.filter(function (p) { return isEarring(p) && p._t.indexOf('cube') !== -1; });
        take(cubes[0]);
        take(cubes[1]);
        /* 4) dobicie najtańszymi z puli */
        for (var j = 0; j < pool.length && picks.length < BMS_ILE; j++) take(pool[j]);
        if (!picks.length) { box.style.display = 'none'; bmsRecsBusy = false; return; }
        var h = '<div class="bms-cart-recs-title">' + (box.dataset.recsTitle || 'Dopełnij wybór') + '</div><div class="bms-cart-recs-grid">';
        picks.forEach(function (p) { h += bmsCard(p, p._min, cartKarat); });
        box.innerHTML = h + '</div>';
        bmsRecsBusy = false;
      });
    }).catch(function () { bmsRecsBusy = false; });
  }
  /* linki #bms-help w treściach otwierają panel Assistance */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href="#bms-help"]');
    if (a && typeof window.bmsHelpToggle === 'function') { e.preventDefault(); window.bmsHelpToggle(e); }
  });

  /* BELLER: chowamy pływający guzik (FAB) Joy Wishlist — serce listy życzeń mamy w nagłówku */
  (function () {
    function hideFab(root) {
      var sr = root && root.shadowRoot;
      if (!sr || sr.__bmsFabHidden) return;
      var st = document.createElement('style');
      /* aplikacja zmienila znacznik guzika z <a> na <div><button>, wiec selektor bez nazwy znacznika */
      st.textContent = '[class*="mib:fixed"]{display:none !important}';
      sr.appendChild(st);
      sr.__bmsFabHidden = 1;
    }
    /* BELLER 24.09.2026: zamiast obserwatora calego dokumentu krotka proba,
       co 500 ms, najwyzej 10 razy, stop po pierwszym sukcesie. */
    var prob = 0;
    (function sprobuj() {
      var root = document.getElementById('mib-wishlist-root');
      var sr = root && root.shadowRoot;
      if (sr && sr.__bmsFabHidden) return;
      hideFab(root);
      if (sr && sr.__bmsFabHidden) return;
      if (++prob < 10) setTimeout(sprobuj, 500);
    })();
  })();

  /* BELLER: strona Lista zyczen (app proxy, shadow DOM + Tailwind - wstrzykujemy arkusz do shadowRoot).
     Uklad: zdjecie wizerunkowe z lewej (sticky) z podpisem jak kafelki strony glownej
     (tytul + przelacznik widokow na zdjeciu, lewy dol), produkty od gornej krawedzi zdjecia.
     Usuwanie: wypelnione serduszko na zdjeciu produktu -> popup potwierdzenia w stylu strony. */
  (function () {
    var EN = (document.documentElement.lang || '').indexOf('en') === 0;
    /* BELLER 29.10.2026: wersja niemiecka (Sie) */
    var DE = (document.documentElement.lang || '').indexOf('de') === 0;
    /* BELLER 31.10.2026: wersja francuska (vous) */
    var FR = (document.documentElement.lang || '').indexOf('fr') === 0;
    /* BELLER 2.11.2026: wersja ukrainska (Ви) */
    var UK = (document.documentElement.lang || '').indexOf('uk') === 0;
    var T = EN ? {
      title: 'Wishlist', views: ['Composition', 'Grid', 'List'],
      confirm: 'Remove from your wishlist?', yes: 'Remove', no: 'Keep'
    } : DE ? {
      title: 'Wishlist', views: ['Komposition', 'Raster', 'Liste'],
      confirm: 'Aus der Wunschliste entfernen?', yes: 'Entfernen', no: 'Behalten'
    } : FR ? {
      title: 'Mes favoris', views: ['Composition', 'Grille', 'Liste'],
      confirm: 'Retirer de mes favoris ?', yes: 'Retirer', no: 'Conserver'
    } : UK ? {
      title: 'Список бажань', views: ['Композиція', 'Сітка', 'Список'],
      confirm: 'Видалити зі списку бажань?', yes: 'Видалити', no: 'Залишити'
    } : {
      title: 'Wishlist', views: ['Kompozycja', 'Siatka', 'Lista'],
      confirm: 'Usunąć z listy życzeń?', yes: 'Usuń', no: 'Zatrzymaj'
    };
    var MODES = ['compo', 'grid', 'list'];
    var HERO_IMG = 'https://beller.pl/cdn/shop/files/4_42-90.webp?v=1772443843&width=1400';
    var HEART = "url(\"data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 18 18%27><path d=%27M12.164,2c-1.195,.015-2.324,.49-3.164,1.306-.84-.815-1.972-1.291-3.178-1.306-2.53,.015-4.582,2.084-4.572,4.609,0,5.253,5.306,8.429,6.932,9.278,.256,.133,.537,.2,.818,.2s.562-.067,.817-.2c1.626-.848,6.933-4.024,6.933-9.275,.009-2.528-2.042-4.597-4.586-4.612Z%27 fill=%27%23151515%27/></svg>\") center/contain no-repeat";
    var BAG = "url(\"data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23151515%27 stroke-width=%271%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27><path d=%27M5.5 8.5h13l-1.1 11.5h-10.8z%27/><path d=%27M9 8.5V7a3 3 0 0 1 6 0v1.5%27/></svg>\") center/contain no-repeat";
    var CSS = [
      ':host{font-family:inherit}',
      /* szkielet ladowania aplikacji: chowamy, w zamian pulsujacy imiennik BELLER */
      '[data-bms-root] [class*="animate-pulse"],[data-bms-root] [class*="skeleton-shimmer"]{display:none !important;animation:none !important}',
            '[data-bms-root]>div{padding:0 !important;max-width:none !important}',
      '[data-bms-root]>div>div{max-width:none !important;margin:0 !important;display:grid !important;grid-template-columns:1fr 1fr;align-items:start}',
      '[data-bms-root]>div>div>*{grid-column:2}',
      
      '[class*="mb-8"]{display:none !important}',
      /* kolumna zdjecia z podpisem jak kafelki home */
      '.bms-hero-col{grid-column:1 !important;grid-row:1/span 9;position:sticky;top:0;height:100vh;background:url(' + HERO_IMG + ') center/cover no-repeat;display:flex !important;align-items:flex-end}',
      '.bms-hero-overlay{padding:0 0 56px 50px;color:#fff}',
      '.bms-hero-title{display:inline-block;font-size:15px;font-weight:500;letter-spacing:.01em}',
      '.bms-hero-title sup{font-size:9px;font-weight:400;margin-left:4px;opacity:.8}',
      /* produkty od gornej krawedzi zdjecia */
      '[data-bms-root] [class*="py-6"]{padding:0 50px 48px !important;height:100vh;overflow-y:auto !important;overflow-x:hidden !important;scrollbar-width:none;opacity:0;transition:opacity .45s ease}',
      '[data-bms-root] [class*="py-6"].bms-grid-in{opacity:1}',
      '[data-bms-root] [class*="py-6"]::-webkit-scrollbar{display:none}',
      /* karty */
      '.grid3>div{display:flex !important;flex-direction:column !important;border:0 !important;padding:0 !important;overflow:visible !important;border-radius:0 !important;position:relative}',
      '.grid3 img{aspect-ratio:260/364 !important;height:auto !important;object-fit:cover !important;background:#f6f6f6;width:100% !important;border-radius:0 !important}',
      '.grid3>div>a{position:relative;display:block}',
      '.grid3 img.bms-img2{position:absolute;inset:0;height:100% !important;opacity:0;transition:opacity .35s ease}',
      '@media(hover:hover){.grid3>div>a:hover img.bms-img2{opacity:1}}',
      '.grid3 [class*="text-center"]{text-align:left !important}',
      '.grid3 [class*="p-2"]{padding:15px 0 0 !important;gap:0 !important}',
      '.grid3 [class*="gap-1"]{gap:0 !important}',
      '.grid3 a[class*="text-sm"]{font-size:10px !important;font-weight:500 !important;text-transform:uppercase;letter-spacing:normal !important;color:#000;text-decoration:none;line-height:normal;padding:0 !important;margin:0 !important}',
      '.grid3 span[class*="text-sm"]{font-size:10px !important;font-weight:400 !important;color:#727272 !important;padding:0 !important;margin:0 !important}',
      '.grid3 div[class*="items-center"][class*="gap-2"]{display:block !important;padding:0 !important;margin:2px 0 0 !important;min-height:0 !important;height:auto !important;line-height:1.2 !important}',
      '.bms-line{display:flex;justify-content:space-between;align-items:flex-start;gap:12px;min-height:0;margin:0;padding:0}',
      '.grid3 button.bms-add{background:' + BAG + ' !important;border:0 !important;padding:0 !important;font-size:0 !important;width:14px !important;height:14px !important;flex:0 0 14px;margin-top:-1px !important;cursor:pointer}',
      /* wypelnione serduszko na zdjeciu produktu */
      '.grid3 button.bms-del{position:absolute;top:10px;right:10px;z-index:3;background:' + HEART + ' !important;border:0 !important;padding:0 !important;font-size:0 !important;width:15px !important;height:15px !important;cursor:pointer;transition:opacity .15s}',
      '.grid3 button.bms-del:hover{opacity:.7}',
      /* popup potwierdzenia w stylu strony */
      '.bms-confirm{position:fixed;inset:0;z-index:99;background:rgba(17,17,17,.45);display:flex;align-items:center;justify-content:center}',
      '.bms-confirm-panel{background:#fff;padding:24px 28px;max-width:270px;width:calc(100% - 32px);text-align:center}',
      '.bms-confirm-panel p{margin:0 0 18px;font-size:11px;letter-spacing:.02em;color:#151515;text-transform:uppercase}',
      '.bms-confirm-panel .bms-yes{background:#151515;color:#fff;border:0;padding:10px 22px;font-family:inherit;font-size:10px;letter-spacing:.12em;text-transform:uppercase;cursor:pointer}',
      '.bms-confirm-panel .bms-no{background:none;border:0;margin-left:18px;font-family:inherit;font-size:10px;letter-spacing:.02em;text-transform:uppercase;color:#767676;text-decoration:underline;text-underline-offset:3px;cursor:pointer}',
      /* kompozycja wg liczby sztuk */







      '.grid3{display:grid !important;grid-template-columns:repeat(2,minmax(0,1fr)) !important;gap:40px 16px !important;padding-top:0}',



      '@media(max-width:767px){',
      '[data-bms-root]>div>div{display:block !important}',
      '.bms-hero-col{position:static;height:auto;aspect-ratio:4/5}',
      '.bms-hero-overlay{padding:0 0 24px 16px}',
      '[data-bms-root] [class*="py-6"]{padding:18px 16px 56px !important;height:auto !important;overflow:visible !important}',

      '}'
    ].join('\n');
    function ensure() {
      var root = document.getElementById('mib-wishlist-page-root');
      var sr = root && root.shadowRoot;
      if (!sr) return;
      if (!sr.querySelector('style[data-bms]')) {
        var st = document.createElement('style');
        st.setAttribute('data-bms', '1');
        st.textContent = CSS;
        sr.appendChild(st);
      }
      var outer = [].find.call(sr.children, function (el) { return el.tagName !== 'STYLE'; });
      if (!outer) return;
      if (!outer.hasAttribute('data-bms-root')) outer.setAttribute('data-bms-root', '1');
      var inner = outer.querySelector(':scope > div > div');
      if (!inner) return;
      /* kolumna zdjecia z tytulem i przelacznikiem */
      if (!inner.querySelector('.bms-hero-col')) {
        var col = document.createElement('div');
        col.className = 'bms-hero-col';
        var ov = document.createElement('div');
        ov.className = 'bms-hero-overlay';
        var ti = document.createElement('span');
        ti.className = 'bms-hero-title';
        ti.textContent = T.title;
        var sup = document.createElement('sup');
        ti.appendChild(sup);
        ov.appendChild(ti);
        col.appendChild(ov);
        inner.insertBefore(col, inner.firstChild);
      }
      /* schowaj naglowek aplikacji (h3), zastepuje go podpis na zdjeciu */
      var h3app = inner.querySelector(':scope > div h3, :scope > h3');
      if (h3app) {
        var headRow = h3app.closest('[class*="flex"]') || h3app.parentElement;
        if (headRow && !headRow.classList.contains('bms-hero-overlay')) headRow.style.setProperty('display', 'none', 'important');
      }
      var n = sr.querySelectorAll('.grid3 > div').length;
      var cnt = String(Math.min(n || 1, 7));
      if (outer.getAttribute('data-bms-count') !== cnt) outer.setAttribute('data-bms-count', cnt);
      var supEl = inner.querySelector('.bms-hero-title sup');
      if (supEl) { var lab = n ? String(n) : ''; if (supEl.textContent !== lab) supEl.textContent = lab; }
      /* karty: torebka przy tytule, serduszko na zdjeciu zamiast Usun */
      sr.querySelectorAll('.grid3 [class*="p-2"]:not([data-bms-rows])').forEach(function (info) {
        var t = info.querySelector('a[class*="text-sm"]');
        var btns = info.querySelectorAll('button');
        var card = info.closest('.grid3 > div') || info.parentElement;
        if (!t || btns.length < 2 || !card) return;
        var wrap = t.parentElement;
        btns[0].classList.add('bms-add');
        btns[1].classList.add('bms-del');
        var r1 = document.createElement('div');
        r1.className = 'bms-line';
        wrap.insertBefore(r1, wrap.firstChild);
        r1.appendChild(t);
        r1.appendChild(btns[0]);
        card.appendChild(btns[1]);
        var old = info.querySelector('div[class*="mt-2"]');
        if (old && !old.querySelector('button')) old.remove();
        info.setAttribute('data-bms-rows', '1');
      });
      /* inline !important: tailwind aplikacji uzywa !important w warstwie, ktora bije nasz arkusz */
      sr.querySelectorAll('button.bms-add').forEach(function (bt) {
        if (bt.__bmsSized) return;
        bt.__bmsSized = 1;
        ['width:14px', 'height:14px', 'padding:0', 'min-height:0', 'flex:0 0 14px', 'margin:0'].forEach(function (d) {
          var kv = d.split(':');
          bt.style.setProperty(kv[0], kv[1], 'important');
        });
      });
      sr.querySelectorAll('.bms-line a[class*="text-sm"]').forEach(function (tl) {
        if (tl.__bmsSized) return;
        tl.__bmsSized = 1;
        ['flex:1 1 auto', 'width:auto', 'padding:0', 'margin:0'].forEach(function (d) {
          var kv = d.split(':');
          tl.style.setProperty(kv[0], kv[1], 'important');
        });
      });
      /* drugie zdjecie na hover, jak na gridzie kolekcji */
      sr.querySelectorAll('.grid3 > div > a:not([data-bms-img2])').forEach(function (aEl) {
        aEl.setAttribute('data-bms-img2', '1');
        var mh = (aEl.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
        if (!mh) return;
        /* tytul w jezyku strony: .js nie wspiera locale (404 na /en/), suggest.json tak */
        if (EN || DE || FR || UK) {
          fetch((EN ? '/en' : DE ? '/de' : FR ? '/fr' : '/uk') + '/search/suggest.json?q=' + mh[1] + '&resources[type]=product&resources[limit]=1')
            .then(function (r) { return r.json(); })
            .then(function (d) {
              var hit = d && d.resources && d.resources.results && d.resources.results.products && d.resources.results.products[0];
              var tEl = aEl.parentElement.querySelector('a[class*="text-sm"]');
              if (hit && hit.title && tEl && tEl.textContent.trim() !== hit.title) tEl.textContent = hit.title;
            }).catch(function () {});
        }
        fetch('/products/' + mh[1] + '.js').then(function (r) { return r.json(); }).then(function (prod) {
          var src = prod && prod.images && prod.images[1];
          if (!src) return;
          if (src.indexOf('//') === 0) src = 'https:' + src;
          src += (src.indexOf('?') === -1 ? '?' : '&') + 'width=800';
          var im = document.createElement('img');
          im.className = 'bms-img2';
          im.loading = 'lazy';
          im.alt = '';
          im.src = src;
          aEl.appendChild(im);
        }).catch(function () {});
      });
      /* format ceny jak na gridzie: bez ",00" */
      sr.querySelectorAll('.grid3 span[class*="text-sm"]').forEach(function (s) {
        if (/,00\s*zł/.test(s.textContent)) s.textContent = s.textContent.replace(/,00(\s*zł)/, '$1');
      });
      /* siatka: drugi etap odslony, gdy produkty gotowe */
      var pane = sr.querySelector('[class*="py-6"]');
      if (pane && !pane.classList.contains('bms-grid-in')) {
        var maProdukty = !!sr.querySelector('.grid3 > div');
        /* stan pusty: aplikacja zhydratowana (jest h3), skeleton juz nie mruga, produktow brak */
        var pustyGotowy = !maProdukty && sr.querySelector('h3') && !sr.querySelector('[class*="skeleton-shimmer"]');
        if (maProdukty || pustyGotowy) pane.classList.add('bms-grid-in');
      }
      if (root.classList.contains('bms-ready') && sr.querySelector('.bms-grid-in')) bmsHideStage();
      /* pusty stan w naszej typografii + nasze serce (inline important - tailwind app ma ! w warstwie) */
      (function () {
        if (!pane) return;
        var eh = pane.querySelector('h3');
        if (eh && !eh.__bmsTyped) {
          eh.__bmsTyped = 1;
          [['font-size','10px'],['font-weight','500'],['text-transform','uppercase'],['letter-spacing','normal'],['color','#151515'],['margin','16px 0 5px'],['line-height','normal']].forEach(function (kv) { eh.style.setProperty(kv[0], kv[1], 'important'); });
        }
        var ep = pane.querySelector('p');
        if (ep && !ep.__bmsTyped) {
          ep.__bmsTyped = 1;
          [['font-size','10px'],['color','#727272'],['line-height','1.7'],['margin','0']].forEach(function (kv) { ep.style.setProperty(kv[0], kv[1], 'important'); });
        }
        var ico = pane.querySelector('[class*="rounded-full"]');
        if (ico && !ico.__bmsTyped) {
          ico.__bmsTyped = 1;
          var HEART_THIN = 'url("data:image/svg+xml;utf8,<svg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 18 18%27 fill=%27none%27 stroke=%27%23151515%27><path d=%27M8.529,15.222c.297,.155,.644,.155,.941,0,1.57-.819,6.529-3.787,6.529-8.613,.008-2.12-1.704-3.846-3.826-3.859-1.277,.016-2.464,.66-3.173,1.72-.71-1.06-1.897-1.704-3.173-1.72-2.123,.013-3.834,1.739-3.826,3.859,0,4.826,4.959,7.794,6.529,8.613Z%27 stroke-width=%270.75%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/></svg>") center/contain no-repeat';
          [['width','24px'],['height','24px'],['border-radius','0'],['background',HEART_THIN]].forEach(function (kv) { ico.style.setProperty(kv[0], kv[1], 'important'); });
          var isvg = ico.querySelector('svg');
          if (isvg) isvg.style.setProperty('display', 'none', 'important');
        }
      })();
      /* odslona strony: uklad zbudowany + zdjecie wczytane */
      if (bmsImgReady && sr.querySelector('.bms-hero-col') && sr.querySelector('style[data-bms]')) {
        root.classList.add('bms-ready');
      }
      /* potwierdzenie usuniecia */
      if (!sr.__bmsConfirmArmed) {
        sr.__bmsConfirmArmed = 1;
        sr.addEventListener('click', function (e) {
          /* torebka: dodajemy przez AJAX i otwieramy szuflade (app przeladowywal strone) */
          var add = e.target.closest && e.target.closest('button.bms-add');
          if (add) {
            var cardEl = add.closest('.grid3 > div');
            var aEl = cardEl && cardEl.querySelector('a[href*="/products/"]');
            var mv = aEl ? (aEl.getAttribute('href') || '').match(/[?&]variant=(\d+)/) : null;
            if (mv) {
              e.preventDefault();
              e.stopImmediatePropagation();
              e.stopPropagation();
              fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(mv[1], 10), quantity: 1 }] }) })
                .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
                .then(function () {
                  fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                    var el = document.querySelector('.barracuda-cart-opener .count');
                    if (el) el.textContent = '' + cart.item_count;
                    var cc = document.querySelector('.barracuda-cart-opener .count-container');
                    if (cc && cart.item_count > 0) cc.classList.remove('hide');
                  }).catch(function () {});
                  var op = document.querySelector('.barracuda-cart-opener');
                  if (op) { op.click(); }
                  else if (typeof window.openTopbar === 'function') { try { window.openTopbar(new MouseEvent('click'), 'cart'); } catch (err) {} }
                })
                .catch(function () {});
            }
            return;
          }
          var del = e.target.closest && e.target.closest('button.bms-del');
          if (!del || del.__bmsAllowed) { if (del) del.__bmsAllowed = 0; return; }
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();
          var back = document.createElement('div');
          back.className = 'bms-confirm';
          var panel = document.createElement('div');
          panel.className = 'bms-confirm-panel';
          var msg = document.createElement('p');
          msg.textContent = T.confirm;
          var yes = document.createElement('button');
          yes.className = 'bms-yes';
          yes.textContent = T.yes;
          var no = document.createElement('button');
          no.className = 'bms-no';
          no.textContent = T.no;
          panel.appendChild(msg); panel.appendChild(yes); panel.appendChild(no);
          back.appendChild(panel);
          sr.appendChild(back);
          function close() { back.remove(); }
          no.addEventListener('click', close);
          back.addEventListener('click', function (ev) { if (ev.target === back) close(); });
          yes.addEventListener('click', function () {
            close();
            del.__bmsAllowed = 1;
            del.click();
          });
        }, true);
      }
    }
    /* scena powitalna: natychmiast, w light DOM, bez czekania na aplikacje */
    (function () {
      var root0 = document.getElementById('mib-wishlist-page-root');
      if (!root0 || document.querySelector('.bms-wish-stage')) return;
      var st = document.createElement('div');
      st.className = 'bms-wish-stage';
      st.innerHTML = '<div class="bms-wish-stage-left"><span class="bms-wish-stage-title">' + T.title + '</span></div><div class="bms-wish-stage-right"></div>';
      try { root0.parentNode.style.position = 'relative'; } catch (e) {}
      /* scena zaczyna sie dokladnie tam, gdzie strona (pod naglowkiem) - zdjecie bez skoku wysokosci */
      try { st.style.top = root0.offsetTop + 'px'; } catch (e) {}
      root0.parentNode.insertBefore(st, root0);
    })();
    function bmsHideStage() {
      var st = document.querySelector('.bms-wish-stage');
      if (st && !st.classList.contains('bms-out')) {
        st.classList.add('bms-out');
        setTimeout(function () { st.remove(); }, 500);
      }
    }
    var bmsImgReady = 0;
    (function () {
      var im = new Image();
      im.onload = im.onerror = function () { bmsImgReady = 1; };
      /* BELLER 26.10.2026, szybkość: zdjęcie tła tylko na stronie listy życzeń (wcześniej 110 KB na każdej stronie) */
      if (document.getElementById('mib-wishlist-page-root')) { im.src = HERO_IMG; } else { bmsImgReady = 1; }
      setTimeout(function () {
        var r = document.getElementById('mib-wishlist-page-root');
        if (r) r.classList.add('bms-ready');
      }, 2500);
      setTimeout(function () {
        var r = document.getElementById('mib-wishlist-page-root');
        var sr2 = r && r.shadowRoot;
        var pane2 = sr2 && sr2.querySelector('[class*="py-6"]');
        if (pane2) pane2.classList.add('bms-grid-in');
        bmsHideStage();
      }, 9000);
    })();
    function safeEnsure() { try { ensure(); } catch (e) {} }
    safeEnsure();
    var root0 = document.getElementById('mib-wishlist-page-root');
    if (root0) {
      var armed = 0;
      setInterval(function () {
        safeEnsure();
        var sr = root0.shadowRoot;
        if (sr && !armed) {
          armed = 1;
          new MutationObserver(safeEnsure).observe(sr, { childList: true, subtree: true });
        }
      }, 300);
    }
  })();

  /* iOS: motyw (global.js noScrollTouchMove) preventDefault-uje touchmove sprawdzając scroll
     na #cart.scroll-inside (overflow hidden po przebudowie) — zatrzymujemy propagację na realnym
     scrollerze (.topbar-content), zanim event dobije do handlera motywu; body i tak jest zablokowane. */
  document.addEventListener('DOMContentLoaded', function () {
    var tc = document.querySelector('#cart .topbar-content');
    if (tc) {
      tc.addEventListener('touchmove', function (e) { e.stopPropagation(); }, { passive: true });
      tc.addEventListener('touchstart', function (e) { e.stopPropagation(); }, { passive: true });
    }
  });

  /* wypełniaj po każdej podmianie treści koszyka (AJAX) + animacja odświeżenia przy dodaniu */
  var bmsCartEl = null;
  var bmsAnimTs = 0;
  document.addEventListener('DOMContentLoaded', function () {
    bmsCartEl = document.getElementById('cart');
    if (!bmsCartEl) return;
    new MutationObserver(function () {
      bmsFillRecs();
      var now = Date.now();
      if (now - bmsAnimTs > 700) {
        var mc = bmsCartEl.querySelector('.main-cart');
        if (mc && mc.childElementCount) {
          bmsAnimTs = now;
          mc.classList.remove('bms-refreshing');
          void mc.offsetWidth;
          mc.classList.add('bms-refreshing');
          setTimeout(function () { mc.classList.remove('bms-refreshing'); }, 520);
        }
      }
    }).observe(bmsCartEl, { childList: true, subtree: true });
  });

  /* BELLER 24.09.2026: checkbox regulaminu zdjety z koszyka, zgoda jest zdaniem nad przyciskiem.
     Obsluga natywnego dymka i komunikatu bms-terms-note usunieta razem z nim. */

  /* "Zapakuj na prezent" — checkbox zapisuje atrybut zamówienia (widoczny w kasie i zamówieniu) */
  document.addEventListener('change', function (ev) {
    var cb = ev.target.closest('#bms-gift-wrap-checkbox');
    if (!cb) return;
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Pakowanie na prezent': cb.checked ? 'Tak' : '' } })
      });
    } catch (e) {}
  }, true);
})();

/* BELLER 16.10.2026: cyfra w kolku koszyka na srodku. Atrybut data-n (ustawiany tez w Liquid, w snippets/icons.liquid)
   pozwala w CSS dosunac sama jedynke, ktora w Avenir Next stoi 0,6 px w lewo. Tu tylko aktualizacja po zmianie koszyka. */
(function () {
  function ustaw() {
    document.querySelectorAll('.barracuda-cart-opener .count').forEach(function (c) {
      var n = (c.textContent || '').trim();
      if (c.getAttribute('data-n') !== n) c.setAttribute('data-n', n);
    });
  }
  ustaw();
  var mo = new MutationObserver(ustaw);
  document.querySelectorAll('.barracuda-cart-opener .count').forEach(function (c) {
    mo.observe(c, { childList: true, characterData: true, subtree: true });
  });
})();
